<template lang="html">
  <div style="height: 100%;">
    <v-card class="mb-1 mt-2">
      <v-card-title>
        <h3 class="headline mb-0">{{ titlePage }}</h3>
      </v-card-title>
      <tree-list v-if="mostrarTreeList"
        :disabled="somenteLeitura"
        :data-source="extensoes"
        ref="treeList"
        coluna-chave="id"
        :search-panel="true"
        :cache-enabled="false"
        :search-placeholder="$t('label.pesquisar')"
        coluna-tem-item="tem_item"
        coluna-chave-pai="idPai"
        :colunas="colunas">
      </tree-list>
    </v-card>
  </div>
</template>

<script>
import Confirm from '../../../shared-components/vuetify/dialog/Confirm';
import TreeList from '../../../shared-components/treeList/TreeList';

export default {
  name: 'TabelaRecursiva',
  components: {
    Confirm,
    TreeList,
  },
  props: {
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
    titlePage: String,
    idNivelExtensao: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      mostrarTreeList: true,
      extensoes: [],
      colunas: [
        {
          dataField: '',
          caption: '',
          cellTemplate: (element, info) => {
            if (!this.somenteLeitura) {
              element.append('<button type="button" style="margin: 0px 0px 0px 15px; padding: 0px; height: auto; min-height: auto" '
                .concat('class="md-button md-icon-button md-theme-default" onclick="TreeView_editPorId(')
                .concat(info.data.id)
                .concat(')"><i aria-hidden="true" class="v-icon material-icons">edit</i>'
                  .concat('</button>')));
            }
          },
        },
        {
          dataField: 'idExterno',
          caption: this.$tc('label.codigo', 1),
          minWidth: 300,
        },
        {
          dataField: 'nomExtensao',
          caption: this.$tc('label.descricao', 1),
        },
        {
          dataField: 'indAtivo',
          caption: this.$tc('label.ativo', 1),
        },
      ],
      esperar: false,
      headers: [
        {
          text: '', value: 'acoes', sortable: false, align: 'center',
        },
        { text: this.$tc('label.codigo', 1), value: 'id_externo' },
        { text: this.$tc('label.descricao', 1), value: 'nom_extensao' },
        { text: this.$tc('label.ativo', 1), value: 'ind_ativo' },
      ],
      nivelClienteResources: this.$api.nivelCliente(this.$resource),
      pagination: {},
      totalPage: 0,
      search: '',
    };
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
  },
  methods: {
    buscar() {
      if (this.search) {
        this.pagination.page = 1;
      }

      const params = {
        nome: this.search,
        page: this.pagination.page,
        tamanhoPagina: 1000,
        asc: true,
        colunaOrdenacao: 'id',
        idNivelExtensao: this.idNivelExtensao,
      };

      this.nivelClienteResources.extensoesRecusiva(params).then((response) => {
        this.extensoes = response.data.resposta;
        const filhos = [];
        this.extensoes.forEach((extensao) => {
          extensao.filhos = extensao.filhos
            ? JSON.parse(extensao.filhos.value) : [];
          extensao.filhos.forEach((filho) => {
            filhos.push(filho);
          });
        });

        this.extensoes = this.extensoes.concat(filhos);

        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.recarregar();
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    editItem(item) {
      this.$emit('edit', item);
    },
    editPorId(id) {
      const item = this.extensoes.filter((e) => e.id === id)[0];
      this.editItem(item);
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 5E2);
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    recarregar() {
      this.mostrarTreeList = false;
      setTimeout(() => {
        this.mostrarTreeList = true;
      });
      // this.$refs.treeList.reload();
    },
  },
  mounted() {
    this.filtrar();
    window.TreeView_editPorId = this.editPorId; // eslint-disable-line
  },
};
</script>
<style>
  .icon-size {
    font-size: 17px;
  }
</style>
